<wm-common-overlay-modal
  [class.contained-overlay]="containedOverlay"
  [bodyPadding]="'0'"
  [isOpen]="true"
  [headerTitle]="headerTitle"
  maxWidth="1086px" minHeight="420px" (closed)="close()">
  <div class="inner-container">
    <div class="inner">
      <div class="column-settings">

        <!-- FORM -->
        <div class="column-settings-body">

          <!-- NAME -->
          <div class="form-field">
            <label class="form-label">Name <span class="required-indicator">*</span></label>

            <div class="field-control name-dropdown-container entity-name-field">
              <!-- Added by Amisha on 05/21/2026 so typing stays free-form and
                   the Global Entities picker opens only from the search icon. -->
              <div class="name-search-input-wrapper">
                <wm-common-textfield
                  [data]="{
                    placeholder: 'Name',
                    value: nameSearch,
                    endIcon: {
                      matIconName: 'search',
                      onIconClick: openNameDropdown.bind(this)
                    }
                  }"
                  (valueChange)="onNameSearchChange($event)">
                </wm-common-textfield>
              </div>

              <div class="name-dropdown-panel" *ngIf="showNameDropdown">
                <div class="name-dropdown-group-title">Global Entities</div>
                <div
                  class="name-dropdown-item"
                  *ngFor="let option of filteredEntityOptions"
                  [class.selected]="column.name === option.value"
                  (click)="selectNameOption(option)">
                  {{ option.label }}
                </div>
              </div>
            </div>
          </div>


          <!-- HEADER -->
          <div class="form-field">
            <label class="form-label">Header <span class="required-indicator">*</span></label>

            <div class="field-control">
              <wm-common-textfield [data]="{
                placeholder: 'Header',
                value: column.header
              }" (valueChange)="column.header = $event">
              </wm-common-textfield>
            </div>
          </div>


          <!-- DATA TYPE -->
          <div class="form-field data-type-field">
            <label class="form-label">Data Type <span class="required-indicator">*</span></label>
            <div class="field-control name-dropdown-container data-type-dropdown-field">
              <div class="name-search-input-wrapper" (click)="openDataTypeDropdown()">
                <wm-common-textfield
                  [data]="{
                    placeholder: 'Select',
                    value: selectedDataTypeLabel,
                    readonly: true,
                    endIcon: {
                      matIconName: 'keyboard_arrow_down',
                      onIconClick: openDataTypeDropdown.bind(this)
                    }
                  }">
                </wm-common-textfield>
              </div>

              <div class="name-dropdown-panel data-type-dropdown-panel" *ngIf="showDataTypeDropdown">
                <div
                  class="name-dropdown-item"
                  *ngFor="let option of dataTypeOptions"
                  [class.selected]="column.dataType === option.value"
                  (click)="selectDataType(option)">
                  {{ option.label }}
                </div>
              </div>
            </div>
          </div>

          <div class="form-field availability-field">
            <label class="availability-checkbox">
              <!-- Added by Amisha on 05/21/2026 to expose the same available-column
                   toggle in Janus column settings that exists in the legacy flow. -->
              <input
                type="checkbox"
                [(ngModel)]="column.isAvailableColumn" />
              <span>Is Available Column?</span>
            </label>
          </div>

        </div>




      </div>
      <!-- FOOTER -->
      <div modal-footer class="column-settings-footer">

        <button type="button" class="btn-secondary" (click)="close()">
          CANCEL
        </button>

        <button type="button" class="btn-primary" [disabled]="isSaveDisabled" (click)="save()">
          SAVE
        </button>

      </div>
    </div>

  </div>
</wm-common-overlay-modal>
